/* eslint-disable no-unused-vars */
/**
 * @typedef {Object} TimesheetModificationDetailsViewModelType
 * @property {keyof TimesheetChangeType} type - Type of modification
 * @property {number} differenceInMinutes
 */

import { TimesheetChangeType } from '@/constants/disputes/TimesheetChangeType'

/**
 * @class
 */
export default class TimesheetModificationDetailsViewModel {
  /**
   * Create a new TimesheetModificationDetailsViewModel.
   * @param {TimesheetModificationDetailsViewModelType} params
   */
  constructor(params) {
    /**
     * @type {keyof TimesheetChangeType}
     */
    this.type = params.type
    this.differenceInMinutes = params.differenceInMinutes
  }
}
